import React, { ReactNode } from "react";
import {
    RiBankCardLine,
    RiCodeBoxLine, RiCpuLine, RiHeadphoneLine,
    RiLineChartLine,
    RiListUnordered, RiMoneyDollarCircleLine,
    RiRocket2Line, RiScalesLine, RiShakeHandsLine,
    RiShieldLine, RiTeamLine, RiUserStarLine,
} from "@remixicon/react";
import { JobFunction } from "./__generated__/api";

const ROLES = [
    { icon: RiHeadphoneLine, title: "Customer Support", jobFunction: JobFunction.CustomerSupport },
    { icon: RiCpuLine, title: "Information Technology (IT)", jobFunction: JobFunction.InformationTechnology },
    { icon: RiTeamLine, title: "Human Resources (HR)", jobFunction: JobFunction.HumanResources },
    { icon: RiShieldLine, title: "Security", jobFunction: JobFunction.Security },
    { icon: RiScalesLine, title: "Legal", jobFunction: JobFunction.Legal },
    { icon: RiCodeBoxLine, title: "Engineering", jobFunction: JobFunction.Engineering },
    { icon: RiMoneyDollarCircleLine, title: "Finance", jobFunction: JobFunction.Finance },
    { icon: RiUserStarLine, title: "Executive/Founder", jobFunction: JobFunction.Founder },
    { icon: RiShakeHandsLine, title: "Partnerships", jobFunction: JobFunction.Partnerships },
    { icon: RiRocket2Line, title: "Product", jobFunction: JobFunction.Product },
    { icon: RiBankCardLine, title: "Revenue Operations", jobFunction: JobFunction.RevenueOperations },
    { icon: RiLineChartLine, title: "Sales", jobFunction: JobFunction.Sales },
    { icon: RiListUnordered, title: "Other", jobFunction: JobFunction.Other },
];

export const ROLE_MAP = ROLES.toIdMap("jobFunction");

export default ROLES;
